<div
  *ngIf="!!contactId"
  (click)="openModal($event)"
  class="contact-summary-icon"
  [matTooltip]="tooltipText | translate"
  matTooltipClass="q-tooltip"
>
  <app-icon name="bolt" size="none"></app-icon>
</div>
